var Reverb = window.Reverb || {};

Reverb.Badges = (function () {
  var globalBadge = '[rel=\'total_notifications_badge\']';

  function getCount(badge) {
    return +$(badge).attr('data-notification-count') || 0;
  }

  function setCount(badge, val) {
    return $(badge).attr('data-notification-count', val);
  }

  function changeCount(badge, change) {
    var count = getCount(badge);
    setCount(badge, count += change);

    if (getCount(badge) <= 0) {
      $(badge).removeAttr('data-notification-count');
    }
  }

  function modifyBadge(badgeRel, change) {
    var badges = $('[rel=' + badgeRel + ']');

    badges.each(function (index, badge) {
      changeCount(badge, change);
    });

    changeCount(globalBadge, change);
  }

  function decrementBadge(badgeRel) {
    modifyBadge(badgeRel, -1);
  }

  function incrementBadge(badgeRel) {
    modifyBadge(badgeRel, 1);
  }

  return {
    decrementBadge: decrementBadge,
    incrementBadge: incrementBadge
  };
})();



// WEBPACK FOOTER //
// ./javascripts/components/legacy/badges.js